export default __webpack_public_path__ + "static/media/close.dbc11c65.svg";